import Vue from 'vue';

export default {
    async getBranch(branch) {
        return (await Vue.http.get(`/api/branch/bybranch/${branch}`)).data;
    },
    async getGroupBranches(branchGroup) {
        return (await Vue.http.get(`/api/branch/forwithdrawal/${branchGroup}`)).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/branch.service.js